import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=579190ba&scoped=true&"
import script from "./ReservationDetails.vue?vue&type=script&lang=js&"
export * from "./ReservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=579190ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579190ba",
  null
  
)

export default component.exports